module.exports = __webpack_public_path__ + "static/media/projectweek.d758a9af.jpg";